
import Vue from 'vue';
import App from './App';
import router from './router';

import drag from './config/drag';
Vue.use(drag);
// vuex
import store from './store';

// axios
import  "./aixos/index";

// import "tailwindcss/tailwind.css"

// element
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
Vue.use(ElementUI);


// // i18n 多语言
// import '@/common/lang/lang'
// import i18n from '@/common/lang/index';

// // 工具类
import '@/utils/common.js'



// 自动引入
import  "@/components/base/index";


// 拖拽弹窗，在需要用到拖拽功能的弹窗标签上加v-dialogDrag
import '@/utils/directive.js'
import ConfigUrls from './aixos/urls.js'
Vue.prototype.base_url = ConfigUrls.baseUrl

Vue.config.productionTip = false
let vueThis= new Vue({
   el: '#app',
  router,
  store,
  // i18n,
  components: { App },
  template: '<App/>'
}).$mount('#app')

export default vueThis



// WEBPACK FOOTER //
// ./src/main.js